const title = 'Halo Scores for Key Risk Areas';

export default title;
